import { useMemo } from 'react';
import { useBasket } from '~/features/basket/hooks';
import { InstoreInformationInputs } from '~/features/checkout/models/fields';
import { getCitySearchResults } from '~/shared/hooks/useCitySearch/api/getCitySearchResults';
import { useUtils } from '~/shared/hooks/useUtils';

export const useSubmit = () => {
    const basket = useBasket();
    const { getCountryCode } = useUtils();

    const handlers = useMemo(
        () => ({
            submitInformation: async (
                values: InstoreInformationInputs,
                useAsShipping?: boolean,
            ) => {
                if (!values.city && values.storeZip) {
                    try {
                        const cityData = await getCitySearchResults(values.storeZip);
                        values.city =
                            cityData.find((entry) => entry.postCode === values.storeZip)
                                ?.cityName ?? 'InStore';
                    } catch {
                        values.city = 'InStore';
                    }
                }

                await basket.updateCustomerInfo({
                    email: values.email,
                });

                return basket.setBillingAddress(
                    {
                        address1: values.address1 || 'InStore',
                        city: values.city,
                        firstName: values.firstName,
                        lastName: values.lastName,
                        fullName: `${values.firstName} ${values.lastName}`,
                        phone: String(values.phoneMobile),
                        postalCode: values.postalCode ?? values.storeZip,
                        countryCode: getCountryCode(),
                    },
                    { useAsShipping },
                );
            },
        }),
        [],
    );

    return {
        handlers,
    };
};
